import React from "react";
var __jsx = React.createElement;
import { faAnglesRight, faFile, faRefresh } from "@fortawesome/pro-regular-svg-icons";
import { getDaysUntilDue } from "../../utils";
import TagsList from "../PatientTags/TagsList";
import { formatLastUpdatedTime } from "../../utils/dateTime";
import TextButton from "../common/TextButton";
import CustomMarkdown from "../Chat/CustomMarkdown";
import classNames from "classnames";
import IconWithCount from "../common/IconWithCount";
import ExpandCollapseButton from "../common/ExpandCollapseButton";
import Store from "../../utils/Store";
import Tooltip from "../common/Tooltip";
import { useTranslation } from "react-i18next";
import Loader from "../Loader";
var Summary = function Summary(_ref) {
  var remindersCount = _ref.remindersCount,
    latestReminder = _ref.latestReminder,
    showReminders = _ref.showReminders,
    patientTags = _ref.patientTags,
    customFields = _ref.customFields,
    onToggleTags = _ref.onToggleTags,
    isTagsExpanded = _ref.isTagsExpanded,
    summary = _ref.summary,
    onRefreshSummary = _ref.onRefreshSummary,
    onRefetchSummary = _ref.onRefetchSummary,
    _ref$isSummaryLoading = _ref.isSummaryLoading,
    isSummaryLoading = _ref$isSummaryLoading === void 0 ? false : _ref$isSummaryLoading,
    _ref$isSummaryGenerat = _ref.isSummaryGenerating,
    isSummaryGenerating = _ref$isSummaryGenerat === void 0 ? false : _ref$isSummaryGenerat,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var summaryText = (summary === null || summary === void 0 ? void 0 : summary.summary) || "";
  var updated_at = (summary === null || summary === void 0 ? void 0 : summary.updated_at) || "";
  var formattedUpdatedAt = formatLastUpdatedTime(updated_at);
  var dueText = "",
    daysRemaining = 0;
  if (latestReminder) {
    var _getDaysUntilDue = getDaysUntilDue(latestReminder.remind_after);
    dueText = _getDaysUntilDue.text;
    daysRemaining = _getDaysUntilDue.daysRemaining;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden bg-white dark:bg-gray-900"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between text-gray-600 dark:text-gray-100 bg-white border-b border-gray-200 dark:border-gray-700 dark:bg-gray-800 px-5 py-[3px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-5"
  }, /*#__PURE__*/React.createElement(ExpandCollapseButton, {
    onClick: function onClick() {
      Store.update(function (s) {
        s.isSummaryCollapsed = true;
      });
    },
    title: t("collapse_summary"),
    icon: faAnglesRight
  }), /*#__PURE__*/React.createElement("span", {
    className: "font-medium"
  }, t("case_snapshot"))), /*#__PURE__*/React.createElement(Tooltip, {
    tooltipText: t("label.task"),
    position: "right",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 py-2 px-3 capitalize"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer shrink-0",
    role: "button",
    onClick: showReminders
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(IconWithCount, {
    count: remindersCount,
    icon: faFile,
    iconClassNames: "rotate-180 -scale-x-100"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800",
    role: "button",
    onClick: showReminders
  }, remindersCount && latestReminder ? /*#__PURE__*/React.createElement("div", {
    className: classNames("flex items-center justify-between gap-4 px-5 py-[7px] text-white flex-auto min-w-0", daysRemaining < 0 ? "bg-red-500" : daysRemaining > 7 ? "bg-gray-500" : "bg-amber-600")
  }, /*#__PURE__*/React.createElement("span", {
    className: "truncate",
    title: latestReminder === null || latestReminder === void 0 ? void 0 : latestReminder.context
  }, latestReminder === null || latestReminder === void 0 ? void 0 : latestReminder.context), /*#__PURE__*/React.createElement("span", {
    className: classNames("text-[14px] rounded-full border shrink-0 text-gray-200 flex items-center w-fit", daysRemaining < 0 ? "px-3 py-2 bg-red-500" : daysRemaining > 7 ? "px-3 py-1 bg-gray-500" : "px-3 py-1 bg-amber-600")
  }, dueText)) : /*#__PURE__*/React.createElement("span", {
    className: "px-5 py-[7px] bg-white dark:bg-gray-900 text-gray-500 dark:text-gray-400 italic text-md flex-auto min-w-0"
  }, t("no_reminders"))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-6 grow h-[1px] p-6 overflow-auto scrollbar-light dark:scrollbar bg-white dark:bg-gray-900 [&::-webkit-scrollbar-corner]:bg-transparent [&::-webkit-scrollbar:horizontal]:h-[10px]"
  }, /*#__PURE__*/React.createElement(TagsList, {
    patientTags: patientTags,
    customFields: customFields,
    onToggleTags: onToggleTags,
    isExpanded: isTagsExpanded
  }), isSummaryLoading || isSummaryGenerating ? /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex items-center justify-center text-md text-gray-500 dark:text-gray-400"
  }, /*#__PURE__*/React.createElement(Loader, {
    size: "medium",
    label: isSummaryGenerating ? t("generating_summary") : t("loading_patient_summary")
  })) : hasError ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 flex flex-col gap-3 justify-center items-center text-md text-gray-600 dark:text-gray-400 italic"
  }, /*#__PURE__*/React.createElement("span", null, t("something_went_wrong")), /*#__PURE__*/React.createElement("div", {
    className: "flex gap-2"
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: onRefetchSummary,
    icon: faRefresh
  }, t("button.retry"))))) : summaryText ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-md text-gray-700 dark:text-gray-200"
  }, /*#__PURE__*/React.createElement(CustomMarkdown, {
    markdown: summaryText
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col italic items-end gap-2"
  }, /*#__PURE__*/React.createElement(TextButton, {
    onClick: onRefreshSummary,
    icon: faRefresh,
    disabled: isSummaryLoading
  }, t("refresh")), formattedUpdatedAt && /*#__PURE__*/React.createElement("span", {
    className: "text-sm italic text-gray-500 dark:text-gray-400"
  }, t("last_updated"), ": ", formattedUpdatedAt))) : /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-md text-gray-500 dark:text-gray-400 italic"
  }, t("summary.not_found"))));
};
export default Summary;